import { useEffect } from 'react'
import { useHistory } from 'react-router'
import Fuse from 'fuse.js'
import { useSelector } from 'react-redux'
import { isEmpty, sortBy } from 'lodash'

import RevenueCentersList from 'components/RevenueCenters/RevenueCentersList'
import Pagination from 'components/Pagination'

import {
  getFilteredRevenueCenters,
  getSearchGlobalRevenueCenters,
} from 'store/RevenueCenters/selector'
import { getCurrentPaginationConfig } from 'store/AppState/selector'
import { FUSE_OPTIONS } from 'utils/fuseSettings'
import paginationCoordinator from 'utils/paginationCoordinator'
import { useHandleChangeRows } from 'hooks/pagination/useHandleChangeRows'
import { useHandleClickPage } from 'hooks/pagination/useHandleClickPage'

const RevenueCenters = () => {
  const history = useHistory()
  const handleChangeRows = useHandleChangeRows()
  const handleClickPage = useHandleClickPage()

  const filteredRevenueCenters = useSelector(
    getFilteredRevenueCenters
  )
  const searchGlobalRevenueCentersValue = useSelector(
    getSearchGlobalRevenueCenters
  )
  const currentPaginationConfig = useSelector((state) =>
    getCurrentPaginationConfig(state, 'revenueCenters')
  )

  const revenueCentersList = isEmpty(searchGlobalRevenueCentersValue)
    ? filteredRevenueCenters
    : new Fuse(filteredRevenueCenters, FUSE_OPTIONS)
        .search(searchGlobalRevenueCentersValue)
        .map((revenueCenter) => revenueCenter.item)

  const sortedItems = sortBy(revenueCentersList, 'name')
  const paginator = paginationCoordinator(sortedItems, history)

  const { count, page, goToPage, offset } = paginator

  useEffect(() => {
    // It is temporary solution, will be changed when recreate paginationCoordinator or create pagination connected with api
    history.push({
      pathname: history.location.pathname,
      search: `offset=${
        currentPaginationConfig?.per ?? offset
      }&page=${currentPaginationConfig?.page ?? page}`,
    })

    // eslint-disable-next-line
  }, [currentPaginationConfig?.page, currentPaginationConfig?.offset])

  return (
    <div className="items">
      <div className="header">
        <ul className="header__menu">
          <li className="header__menu-item -shorter-aligment">
            Name
          </li>
          <li className="header__menu-item">Menus Status</li>
        </ul>
      </div>
      <RevenueCentersList revenueCentersList={paginator?.result} />
      <section className="footer">
        <Pagination
          totalItemsCount={count}
          handleChangeRowsPerPage={(event) =>
            handleChangeRows(event, goToPage, 'revenueCenters')
          }
          handleClickPage={(page) =>
            handleClickPage(
              page,
              currentPaginationConfig?.per,
              offset,
              goToPage,
              'revenueCenters'
            )
          }
          pageNumber={page}
          rowsPerPage={currentPaginationConfig?.per ?? offset}
        />
      </section>
    </div>
  )
}

export default RevenueCenters
